<script>
  import { onMount } from "svelte";

  import Details from "./Details.svelte";
  import Footer from "./Footer.svelte";
  import Header from "./Header.svelte";
  import Quizz from "./Quizz.svelte";
  import ThreeD from "./ThreeD.svelte";
  import photoData from "./data.json";
  import About from "./About.svelte";
  import Hint from "./Hint.svelte";

  export let startScan;
  export let imageId;

  let hint = "";
  const hints = {
    zoom: "Zoomez et déplacez votre doigt sur l'image en 3D!",
    tap: "Tapez sur les éléments en jaune pour les découvrir!",
  };

  const HINT_TIMEOUT = 5000;

  const currentPhotoData = photoData[imageId];

  const state = {
    showDetails: false,
    showQuizz: false,
    showAbout: false,
    allaTargetsVisited: false,
    infoPanelData: null,
    hasZoomed: false,
    hasClicked: false,
    needsHint: false,
  };

  onMount(() => {
    // Set a timeout for the hints
    window.setTimeout(() => {
      if (!state.hasZoomed) {
        hint = hints.zoom;
        state.needsHint = true;
      } else if (!state.hasClicked) {
        hint = hints.tap;
        state.needsHint = true;
      }
    }, HINT_TIMEOUT);
  });

  const closePanel = () => {
    state.showDetails = false;

    // Show the zoom hint if the person hasn't zoomed
    // console.log("state haszoomed =", state.hasZoomed);
    if (!state.hasZoomed) {
      window.setTimeout(() => {
        if (!state.hasZoomed) {
          // console.log("Show zoome hint!");
          hint = hints.zoom;
          state.needsHint = true;
        } else {
          // console.log("no need to show zoom hint");
        }
      }, HINT_TIMEOUT / 2);
    }
  };

  const openPanel = (target) => {
    // console.log("set hasclicked to true, set needsHint to false");
    state.hasClicked = true;
    state.needsHint = false;
    hint = "";
    state.infoPanelData = target;
    state.showDetails = true;
  };

  const openQuizz = () => {
    state.showQuizz = true;
  };

  const closeQuizz = () => {
    state.showQuizz = false;
  };

  const openAbout = () => {
    state.showAbout = true;
  };

  const closeAbout = () => {
    state.showAbout = false;
  };

  const setAllTargetsVisited = () => {
    state.allaTargetsVisited = true;
  };

  const disableZoomHint = () => {
    if (!state.hasZoomed) {
      hint = "";
      state.hasZoomed = true;
      state.needsHint = false;

      window.setTimeout(() => {
        state.hasZoomed = true;
        if (!state.hasClicked) hint = hints.tap;
        state.needsHint = true;
      }, HINT_TIMEOUT / 2);
    }
  };
</script>

<div>
  {#if state.showDetails}
    <Details {closePanel} data={state.infoPanelData} {imageId} />
  {/if}
  {#if state.showQuizz}
    <Quizz {closeQuizz} {currentPhotoData} />
  {/if}
  {#if state.showAbout}
    <About {closeAbout} />
  {/if}

  {#if state.needsHint && hint != ""}
    <div
      class="hint-container w-100 relative absolute left-0 flex justify-center"
    >
      <Hint {hint} />
    </div>
  {/if}

  <Header {openAbout} />
  {#if state.allaTargetsVisited}
    <button
      class="quizz-btn bg-custom-yellow br-pill absolute z-1 ph3 flex items-center justify-center"
      on:click={openQuizz}
    >
      <img src="./icones/quiz.svg" class="mr2" alt="" />
      Quiz!
    </button>
  {/if}

  <ThreeD
    {openPanel}
    {currentPhotoData}
    {setAllTargetsVisited}
    isQuizzVisible={state.showQuizz}
    isDetailsVisible={state.showDetails}
    isAboutVisible={state.isAboutVisible}
    {disableZoomHint}
  />
  <Footer {startScan} {currentPhotoData} />
</div>

<style>
  .quizz-btn {
    height: 48px;
    top: 48px;
    left: 50%;
    transform: translateX(-50%);
    animation: shake 2s;
    animation-iteration-count: infinite;
  }

  .hint-container {
    bottom: 72px;
  }

  @keyframes shake {
    0% {
      transform: translateX(-50%) rotate(0deg) scale(1);
    }

    5% {
      transform: translateX(-50%) rotate(15deg) scale(1.2);
    }

    10% {
      transform: translateX(-50%) rotate(-15deg) scale(1.2);
    }

    15% {
      transform: translateX(-50%) rotate(0deg) scale(1);
    }

    100% {
      transform: translateX(-50%) rotate(0deg) scale(1);
    }
  }
</style>
